import { render, staticRenderFns } from "./InvoiceItems.vue?vue&type=template&id=2b207b37&scoped=true&"
import script from "./InvoiceItems.vue?vue&type=script&lang=js&"
export * from "./InvoiceItems.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItems.vue?vue&type=style&index=0&id=2b207b37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b207b37",
  null
  
)

export default component.exports